(function () {
  'use strict';
  if (window.SRCardAdd) return;

  var RESET_MS = 1400;

  function card(el) {
    return el.closest('[data-sr-card]');
  }

  function formats(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('[data-sr-card-format]'));
  }

  function select(scope, button) {
    formats(scope).forEach(function (item) {
      item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
    });

    var price = scope.querySelector('[data-sr-card-price]');
    if (price && button.dataset.price) price.textContent = button.dataset.price;

    var addButton = scope.querySelector('[data-sr-card-add]');
    if (addButton) {
      addButton.dataset.variantId = button.dataset.variantId || '';
      addButton.disabled = false;
    }
  }

  function add(scope, button) {
    var variantId = button.dataset.variantId;
    if (!variantId || !window.SRCart || button.getAttribute('aria-busy') === 'true') return;

    var label = button.querySelector('[data-sr-card-add-label]') || button;
    var original = button.dataset.labelOriginal || label.textContent;
    button.dataset.labelOriginal = original;

    button.setAttribute('aria-busy', 'true');
    label.textContent = button.dataset.labelBusy || 'Agregando…';

    window.SRCart
      .add([{ id: Number(variantId), quantity: 1 }], { source: button, sourceId: 'sr-card-add' })
      .then(function () {
        label.textContent = button.dataset.labelDone || 'Agregado ✓';
      })
      .catch(function () {
        label.textContent = button.dataset.labelError || 'Error';
      })
      .then(function () {
        button.removeAttribute('aria-busy');
        window.setTimeout(function () {
          label.textContent = original;
        }, RESET_MS);
      });
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    var format = event.target.closest('[data-sr-card-format]');
    if (format) {
      var scopeFormat = card(format);
      if (!scopeFormat || format.disabled) return;
      event.preventDefault();
      event.stopPropagation();
      select(scopeFormat, format);
      return;
    }

    var addButton = event.target.closest('[data-sr-card-add]');
    if (!addButton) return;
    var scopeAdd = card(addButton);
    if (!scopeAdd || addButton.disabled) return;
    event.preventDefault();
    event.stopPropagation();
    add(scopeAdd, addButton);
  });

  window.SRCardAdd = true;
})();
